import I18n from 'i18n-js';

import useBooleanState from '~/hooks/useBooleanState';
import { useURLSearchParams } from '~/hooks/useURLSearchParams';
import { MenuOption } from '~/popups/MenuPopup/MenuOptionsGroup/MenuOption';
import { DeleteAccountPopup } from '~/popups/UserDetailsPopup/DeleteAccount/DeleteAccountPopup';

import { ReactComponent as TrashIcon } from '~/assets/images/iconsLibrary/trash.svg';

import styles from './DeleteAccount.module.scss';

const deleteAccountAction = 'delete-account';
export function DeleteAccount(): JSX.Element {
  const initialAction = useURLSearchParams('action');
  const [
    isDeleteAccountPopupOpened,
    { setTrue: openDeleteAccountPopup, setFalse: closeDeleteAccountPopup },
  ] = useBooleanState(initialAction === deleteAccountAction);

  return (
    <>
      {isDeleteAccountPopupOpened && (
        <DeleteAccountPopup close={closeDeleteAccountPopup} />
      )}
      <MenuOption
        className={styles.container}
        labelClassName={styles.label}
        label={I18n.t('MenuView_profile_delete')}
        onClick={openDeleteAccountPopup}
      >
        <TrashIcon className={styles.icon} />
      </MenuOption>
    </>
  );
}
